import axios from '@/libs/api.request'

/**
 * 获取列表
 * @returns {wx.RequestTask | never}
 */
export const getList = (params) => {
  return axios.request({
    url: 'financeManage/withdrawPending/index',
    method: 'get',
    params: params
  })
}




/**
 * 删除数据
 */
export const del = (id) => {
  return axios.request({
    url: 'financeManage/withdrawPending/del',
    method: 'get',
    params: {
      id: id
    }
  })
}

/**
 * changeIsAutoWithdraw
 */
export const changeIsAutoWithdraw = (is_auto_withdraw,pay_channels_id) => {
  return axios.request({
    url: 'financeManage/withdrawPending/changeIsAutoWithdraw',
    method: 'get',
    params: {
      is_auto_withdraw: is_auto_withdraw,
      pay_channels_id:pay_channels_id
    }
  })
}


/**
* 锁定/解锁
*/
export const lock = (id) => {
return axios.request({
url: 'financeManage/withdrawPending/lock',
method: 'get',
params: {
id: id
}
})
}

/**
* 获取列表
* @returns {wx.RequestTask | never}
*/
export const getParams = () => {
return axios.request({
url: 'financeManage/withdrawPending/getParams',
method: 'get'
})
}




/**
 * 改变状态按钮
 * @param status
 * @param id
 * @returns {wx.RequestTask | never}
 */
export const changeStatus = (data) => {
  return axios.request({
    url: 'financeManage/withdrawPending/changeStatus',
    method: 'post',
    data
  })
}

/**
 * 提交代付
 * @param status
 * @param id
 * @returns {wx.RequestTask | never}
 */
export const thirdWidthdraw = (data) => {
  return axios.request({
    url: 'financeManage/withdrawPending/thirdWidthdraw',
    method: 'post',
    data
  })
}


/**
 * 新增
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const add = (data) => {
  return axios.request({
    url: 'financeManage/withdrawPending/add',
    method: 'post',
    data
  })
}

/**
 * 编辑
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const edit = (data) => {
  return axios.request({
    url: 'financeManage/withdrawPending/edit',
    method: 'post',
    data
  })
}
